import { StateNode } from '@tldraw/tldraw'
import { Idle } from './children/Idle'
import { PointingContent } from './children/PointingContent'
import { TranslatingContent } from './children/TranslatingContent'

export class Mask extends StateNode {
  static override id = 'mask'
  static override initial = 'idle'
  static override children = () => [Idle, TranslatingContent, PointingContent]
}
